(() => {
    const elements = document.getElementsByClassName('copy-clipboard');

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        element.addEventListener('click', async (evt) => {
            const attribute = element.getAttribute('data-clipboard');
            await navigator.clipboard.writeText(attribute!);
            alert(element.getAttribute('data-message'));
        });
    }
})();
